import { generateRosterCore, GenerateRosterProps, ProgressCallback } from './generateRosterCore'

type WorkerProgressMessage = ProgressBest & { type: 'progress' }
type WorkerErrorMessage = { type: 'error'; error: string }
type WorkerMessage = WorkerProgressMessage | WorkerErrorMessage

let currentWorker: Worker | null = null
let runId = 0

export function generateRoster(props: GenerateRosterProps & { onProgress: ProgressCallback }): void {
	const { onProgress, ...coreProps } = props
	const myRunId = ++runId

	stopWorker()

	if (typeof Worker !== 'undefined') {
		try {
			currentWorker = new Worker(
				new URL('../workers/roster.worker.ts', import.meta.url),
				{ type: 'module' },
			)

			currentWorker.onmessage = (event: MessageEvent<WorkerMessage>) => {
				if (myRunId !== runId) {
					return
				}
				if (event.data.type === 'progress') {
					const { type, ...update } = event.data
					onProgress(update)
					if (update.ready) {
						stopWorker()
					}
				} else if (event.data.type === 'error') {
					console.error('Roster worker error:', event.data.error)
					stopWorker()
					generateRosterFallback(coreProps, onProgress, myRunId)
				}
			}

			currentWorker.onerror = (error) => {
				if (myRunId !== runId) {
					return
				}
				console.error('Roster worker failed:', error)
				stopWorker()
				generateRosterFallback(coreProps, onProgress, myRunId)
			}

			currentWorker.postMessage({ type: 'generate', payload: coreProps })
			return
		} catch (error) {
			console.warn('Worker creation failed, using main thread:', error)
		}
	}

	generateRosterFallback(coreProps, onProgress, myRunId)
}

export function terminateRosterWorker(): void {
	runId += 1
	stopWorker()
}

function generateRosterFallback(
	props: GenerateRosterProps,
	onProgress: ProgressCallback,
	myRunId: number,
) {
	generateRosterCore(props, (update) => {
		if (myRunId !== runId) {
			return
		}
		onProgress(update)
	}, () => myRunId !== runId)
}

function stopWorker() {
	if (currentWorker) {
		currentWorker.terminate()
		currentWorker = null
	}
}
